(function(){
  // ============================================================
  // Site-wide cart UI refresh.
  //
  // Instead of manually calling a refresh function after every
  // individual Add to Cart button across the theme (product pages,
  // collection pages, any other section, any app's own quick-buy
  // button), this watches the network layer itself for any request
  // that mutates the cart, then refreshes both the header cart-count
  // and the cart drawer's actual contents. This means it works
  // regardless of which specific code path triggered the cart
  // change — including code we don't control (apps, other sections)
  // and code written in the future.
  //
  // Patching is deliberately deferred until the window `load` event.
  // Confirmed live that something else on this site does a one-time
  // reset of XMLHttpRequest.prototype.open back to native during
  // page load (most likely another app's script) — applying our
  // patch before that happens gets silently wiped out, while
  // applying it after page load leaves it untouched indefinitely.
  // ============================================================

  // Cart drawer footer (Taxes/Shipping note + Subtotal) and the
  // outer row containing it plus Shipping/Discount both used a
  // fixed grid with no responsive stacking, breaking on narrow
  // screens; also hides the "Recently viewed" tab from the drawer.
  var style = document.createElement('style');
  style.textContent =
    '@media (max-width: 640px) {' +
    '#CartDrawer .drawer__footer-bottom > .grid.gap-4 { grid-template-columns: 1fr !important; }' +
    '#CartDrawer .drawer__footer-bottom .grid.grid-cols-2 { grid-template-columns: 1fr !important; }' +
    '}' +
    '#CartDrawer button[aria-controls^="RecentlyViewed-sections--"] { display: none !important; }' +
    '#CartDrawer [id^="RecentlyViewed-sections--"] { display: none !important; }';
  document.head.appendChild(style);

  function isCartEndpoint(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)\.js(\?|$)/.test(url);
  }

  function refreshCartUI() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          var cart = JSON.parse(xhr.responseText);
          document.querySelectorAll('cart-count').forEach(function(el){
            if (typeof el.onCartUpdate === 'function') {
              el.onCartUpdate({ cart: cart });
            }
          });
        } catch (e) {}
      }
    };
    xhr.send();

    var drawer = document.getElementById('CartDrawer');
    if (drawer && typeof drawer.onCartRefresh === 'function') {
      try {
        drawer.onCartRefresh({ detail: { open: true } });
      } catch (e) {
        // onCartRefresh also tries to trigger the drawer's own open
        // animation as a side effect, which throws when called
        // outside its normal click-triggered context — harmless to
        // swallow, since the content refresh itself completes
        // successfully before that point.
      }
    }
  }

  function patchCartRequests() {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function(method, url){
      this.__isCartMutation = (method || '').toUpperCase() === 'POST' && isCartEndpoint(url);
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function(){
      if (this.__isCartMutation) {
        this.addEventListener('load', function(){
          if (this.status >= 200 && this.status < 300) {
            refreshCartUI();
          }
        });
      }
      return origSend.apply(this, arguments);
    };

    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url);
      // FIXED: this used to read `init.method` on both sides of the ||,
      // instead of `input.method` on the second — meaning any fetch call
      // with no second argument (the single most common form, e.g.
      // fetch('/some/url')) threw immediately, since init is undefined
      // in that case. That was breaking any fetch on the site that used
      // this shorthand, including things unrelated to cart, like the
      // mobile menu's own content-loading request.
      var method = (init && init.method) || (input && input.method) || 'GET';
      var isMutation = method.toUpperCase() === 'POST' && isCartEndpoint(url);
      var result = origFetch.apply(this, arguments);
      if (isMutation) {
        result.then(function(res){
          if (res && res.ok) refreshCartUI();
          return res;
        }).catch(function(){});
      }
      return result;
    };
  }

  if (document.readyState === 'complete') {
    patchCartRequests();
  } else {
    window.addEventListener('load', patchCartRequests);
  }

  // ============================================================
  // Mega-menu content (mobile "Shop" panel, and any other menu
  // item with a mega-menu block) loads via a Shopify section-
  // rendering component (<api-button>) with its own init() method.
  // A normal tap should trigger this automatically, but confirmed
  // live that it doesn't — the content stays empty until init() is
  // called directly. Same root class of issue as the Add to Cart
  // bug earlier in this project (a real tap not reaching its
  // intended handler) — same fix: a capture-phase delegated
  // listener that doesn't depend on the page's own wiring working.
  // This only steps in if the target content is still empty, so it
  // won't interfere if the native mechanism does fire correctly.
  // ============================================================
  document.addEventListener('click', function(e){
    var summary = e.target.closest('summary');
    if (!summary) return;
    var apiBtn = summary.querySelector('api-button');
    if (!apiBtn || typeof apiBtn.init !== 'function') return;
    var targetId = apiBtn.getAttribute('data-id');
    var targetEl = targetId ? document.getElementById(targetId) : null;
    if (targetEl && targetEl.innerHTML.trim() === '') {
      apiBtn.init();
    }
  }, true);
})();